/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const digipass_private = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={16}
    fill="none"
    viewBox="0 0 18 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M4.75 4.535C2.359 5.227.75 6.52.75 8c0 1.48 1.609 2.773 4 3.465m0-6.93C5.927 4.195 7.293 4 8.75 4c4.418 0 8 1.79 8 4s-3.582 4-8 4c-1.457 0-2.823-.195-4-.535m0-6.93c.5 1.132 1.2 4.102 0 6.93M8.25 8h4.5"
    />
  </svg>
)
export default digipass_private
